import type { CatalogCase, CatalogSort } from './catalog.types';

export const CATALOG_SORT_STORAGE_KEY = 'cases-catalog-sort';
export const ALL_CATEGORIES = 'all';
export const DEFAULT_CATALOG_SORT: CatalogSort = 'price-asc';

const SORTS: string[] = ['top', 'price-asc', 'price-desc', 'new'] satisfies CatalogSort[];

export const isCatalogSort = (value: unknown): value is CatalogSort =>
  typeof value === 'string' && SORTS.includes(value);

export const readStoredCatalogSort = (): CatalogSort => {
  try {
    const stored = window.localStorage.getItem(CATALOG_SORT_STORAGE_KEY);
    return isCatalogSort(stored) ? stored : DEFAULT_CATALOG_SORT;
  } catch {
    return DEFAULT_CATALOG_SORT;
  }
};

export const storeCatalogSort = (sort: CatalogSort) => {
  try {
    window.localStorage.setItem(CATALOG_SORT_STORAGE_KEY, sort);
  } catch {
  }
};

const createdAtMs = (c: CatalogCase) => (c.createdAt ? Date.parse(c.createdAt) : 0);

const orderBy = (cases: CatalogCase[], sort: CatalogSort): CatalogCase[] => {
  const list = [...cases];
  switch (sort) {
    case 'top':
      return list.sort((a, b) => b.openingsCount - a.openingsCount);
    case 'price-asc':
      return list.sort((a, b) => a.priceInCredits - b.priceInCredits);
    case 'price-desc':
      return list.sort((a, b) => b.priceInCredits - a.priceInCredits);
    case 'new':
      return list.sort((a, b) => Number(b.isNew) - Number(a.isNew) || createdAtMs(b) - createdAtMs(a));
  }
};

// WHY: на выкатке новый лендинг получает закэшированные Next'ом ответы старого бэка, где поля ещё нет, — SSR падал на
// .includes и новая версия откатывалась
type MaybePinned = { priorityLanguages?: string[] };

const isPinnedFor = (c: MaybePinned, language: string): boolean => c.priorityLanguages?.includes(language) ?? false;

export const pinForLanguage = <T extends MaybePinned>(cases: T[], language: string): T[] => {
  const pinned = cases.filter((c) => isPinnedFor(c, language));
  if (pinned.length === 0) return cases;
  return [...pinned, ...cases.filter((c) => !isPinnedFor(c, language))];
};

export const sortCatalogCases = (cases: CatalogCase[], sort: CatalogSort, language: string): CatalogCase[] =>
  pinForLanguage(orderBy(cases, sort), language);
